import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-boat-log-registration',
  templateUrl: './boat-log-registration.component.html',
  styleUrls: ['./boat-log-registration.component.scss']
})
export class BoatLogRegistrationComponent implements OnInit {

  @Input() boatLog;
  @Input() isNew;

  oldDatasMap;

  constructor() { }

  ngOnInit(): void {
    this.oldDatasMap = new Map(Object.entries(this.boatLog.oldDatas));
  }

  isChangedApprehend() {
    return this.oldDatasMap.has('apprehend');
  }

  getApprehend(): boolean {
    let apprehend = this.boatLog.apprehend;
    if(this.isChangedApprehend() && !this.isNew) {
      apprehend = this.boatLog.oldDatas.apprehend;
    }
    return apprehend;
  }

  isChangedIndependentTanks() {
    return this.oldDatasMap.has('independentTanks');
  }

  getIndependentTanks(): boolean {
    let independentTanks = this.boatLog.independentTanks;
    if(this.isChangedIndependentTanks() && !this.isNew) {
      independentTanks = this.boatLog.oldDatas.independentTanks;
    }
    return independentTanks;
  }

  isChangedMarineWashMyBoat() {
    return this.oldDatasMap.has('marineWashMyBoat');
  }

  getMarineWashMyBoat(): boolean {
    let marineWashMyBoat = this.boatLog.marineWashMyBoat;
    if(this.isChangedMarineWashMyBoat() && !this.isNew) {
      marineWashMyBoat = this.boatLog.oldDatas.marineWashMyBoat;
    }
    return marineWashMyBoat;
  }

  isChangedMarineRunMyEnginer() {
    return this.oldDatasMap.has('marineRunMyEnginer');
  }

  getMarineRunMyEnginer(): boolean {
    let marineRunMyEnginer = this.boatLog.marineRunMyEnginer;
    if(this.isChangedMarineRunMyEnginer() && !this.isNew) {
      marineRunMyEnginer = this.boatLog.oldDatas.marineRunMyEnginer;
    }
    return marineRunMyEnginer;
  }

  isChangedTimeBetweenWash() {
    return this.oldDatasMap.has('timeBetweenWash');
  }

  getTimeBetweenWash(): number {
    let timeBetweenWash = this.boatLog.timeBetweenWash;
    if(this.isChangedTimeBetweenWash() && !this.isNew) {
      timeBetweenWash = this.boatLog.oldDatas.timeBetweenWash;
    }
    return timeBetweenWash;
  }

  isChangedTimeBetweenEngineRotation() {
    return this.oldDatasMap.has('timeBetweenEngineRotation');
  }

  getTimeBetweenEngineRotation(): number {
    let timeBetweenEngineRotation = this.boatLog.timeBetweenEngineRotation;
    if(this.isChangedTimeBetweenEngineRotation() && !this.isNew) {
      timeBetweenEngineRotation = this.boatLog.oldDatas.timeBetweenEngineRotation;
    }
    return timeBetweenEngineRotation;
  }

  isChangedFullTank() {
    return this.oldDatasMap.has('fullTank');
  }

  getFullTank(): boolean {
    let fullTank = this.boatLog.fullTank;
    if(this.isChangedFullTank() && !this.isNew) {
      fullTank = this.boatLog.oldDatas.fullTank;
    }
    return fullTank;
  }

  isChangedShowAllCustomerData() {
    return this.oldDatasMap.has('showAllCustomerData');
  }

  getShowAllCustomerData(): boolean {
    let showAllCustomerData = this.boatLog.showAllCustomerData;
    if(this.isChangedShowAllCustomerData() && !this.isNew) {
      showAllCustomerData = this.boatLog.oldDatas.showAllCustomerData;
    }
    return showAllCustomerData;
  }

  isChangedSlingMultiQueue() {
    return this.oldDatasMap.has('slingMultiQueue');
  }

  getSlingMultiQueue(): string {
    let slingMultiQueue = this.boatLog.slingMultiQueue;
    if(this.isChangedSlingMultiQueue() && !this.isNew) {
      slingMultiQueue = this.boatLog.oldDatas.slingMultiQueue;
    }
    return slingMultiQueue;
  }

  isChangedActive() {
    return this.oldDatasMap.has('active');
  }

  getActive(): boolean {
    let active = this.boatLog.active;
    if(this.isChangedActive() && !this.isNew) {
      active = this.boatLog.oldDatas.active;
    }
    return active;
  }

  isChangedMaintenance() {
    return this.oldDatasMap.has('maintenance');
  }

  getMaintenance(): boolean {
    let maintenance = this.boatLog.maintenance;
    if(this.isChangedMaintenance() && !this.isNew) {
      maintenance = this.boatLog.oldDatas.maintenance;
    }
    return maintenance;
  }

  isChangedTwoTimeEngine() {
    return this.oldDatasMap.has('twoTimeEngine');
  }

  getTwoTimeEngine(): boolean {
    let twoTimeEngine = this.boatLog.twoTimeEngine;
    if(this.isChangedTwoTimeEngine() && !this.isNew) {
      twoTimeEngine = this.boatLog.oldDatas.twoTimeEngine;
    }
    return twoTimeEngine;
  }

  isChangedAvailableOnApp() {
    return this.oldDatasMap.has('availableOnApp');
  }

  getAvailableOnApp(): boolean {
    let availableOnApp = this.boatLog.availableOnApp;
    if(this.isChangedAvailableOnApp() && !this.isNew) {
      availableOnApp = this.boatLog.oldDatas.availableOnApp;
    }
    return availableOnApp;
  }
}
